import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import Swal from 'sweetalert2';
import { EventDayService } from 'src/app/services/event-day.service';
import { StihlEventDayDTO } from 'src/app/models/stihl-event-dto';
import { visibleContentAnimation } from 'src/app/animations';



@Component({
  selector: 'app-event',
  templateUrl: './event.component.html',
  encapsulation: ViewEncapsulation.Emulated,
  animations: [ visibleContentAnimation ]
})
export class EventComponent implements OnInit {


  @Input() idEventType: string;
  data: StihlEventDayDTO[] = [];
  loaded = false;
  showGallery = false;
  idEventDay;
  @Output() closeEvent = new EventEmitter<boolean>();
  showEventDate = true;


  constructor(private eventDayService: EventDayService) { }


  ngOnInit(): void {
    this.loadEventTypes();
  }

  loadEventTypes() {

    this.eventDayService.GetStihlEventDayLst(this.idEventType).subscribe(resp => {

      if (resp != null && resp != undefined) {
        this.data = resp;
        this.loaded = true;

      }
    }, (err) => {
      Swal.fire({
        icon: 'error',
        title: 'Erro ao recuperar os dados',
        text: 'Ocorreu um erro'
      });
    });
  }



  ShowGallery(id) {
    this.idEventDay = id;
    this.showGallery = true;
    this.closeEvent.emit(true);
  }


  GetCloseGallery(event) {
    this.showGallery = event;
    this.idEventDay = null;
    this.closeEvent.emit(false);
  }

  getshowEventDate(event) {
    this.showEventDate = event;
  }

}
